<div *ngIf="preloaderConfig?.pendingTasks > 0" class="gl-progress-container" [ngClass]="position">
  <gl-progress></gl-progress>
</div>
